import { createSlice } from '@reduxjs/toolkit';
import getAdapter from '../getAdapter';

const insuranceTypesAdapter = getAdapter({ idFieldName: 'value' });

const insuranceTypesSlice = createSlice({
  name: 'insuranceTypes',
  initialState: insuranceTypesAdapter.getInitialState(),
  reducers: {
    setInsuranceTypes: (state, { payload: { insuranceTypes } }) => {
      insuranceTypesAdapter.setAll(state, insuranceTypes);
    },
  },
});

const selectors = insuranceTypesAdapter.getSelectors(({ insuranceTypes }) => insuranceTypes);

export const getInsuranceTypes = (state) => selectors.selectAll(state);

export const { setInsuranceTypes } = insuranceTypesSlice.actions;

export default insuranceTypesSlice.reducer;
